import { render, staticRenderFns } from "./OrganizationJobCategoriesTab.vue?vue&type=template&id=756a09e1&scoped=true"
import script from "./OrganizationJobCategoriesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationJobCategoriesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationJobCategoriesTab.vue?vue&type=style&index=0&id=756a09e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a09e1",
  null
  
)

export default component.exports